import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Cookies from 'js-cookie'
import { ParseJwt } from '../util'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/login',
    name: 'login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/reset_password',
    name: 'reset_password',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "reset_password" */ '../views/ResetPassword.vue')
  },
  {
    path: '/account',
    name: 'account',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "account" */ '../views/Account.vue')
  },
  {
    path: '/simuam',
    name: 'simuam',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "simuam" */ '../views/UserManagement.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to) => {

  if(to.fullPath.includes("http") && !to.fullPath.includes("?getKey") && !to.fullPath.includes("?redirect") && !to.fullPath.includes("?logout") ){
    window["location"] = (to.fullPath.substr(1)) as any
    return
  }

  const token = Cookies.get('API_TOKEN')

  if(token  && to.fullPath.includes("?redirect")){

    const params = new URLSearchParams(document.location.search);
    const r = params.get("redirect");

    const jwtdict = ParseJwt(token as string)
    
    if (r && jwtdict.exp * 1000 > Date.now()){
      window["location"] = r as any
      return
    }

  }

  if(token && (to.name === 'login' || to.name === 'reset_password' ) ){
      return { name : 'home' }
  }

  if (!token && (to.name !== 'login' && to.name !== 'reset_password' ) ){
      return { name: 'login' } 
  }
})

export default router
